import { createConfirmation } from "react-confirm";
import ScheduleModal from "./ScheduleModal";

export const showScheduleModal = createConfirmation(ScheduleModal);
